var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:_vm.className + ' ' + _vm.type,attrs:{"disabled":_vm.disabled},on:{"click":function($event){!_vm.disabled && _vm.$emit('click')}}},[_c('div',{staticClass:"button-border"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }